import { Result } from '../../api/api';

export const FIRMWARE_ROLLOUT_BATCH_SIZE = 1000;

export interface FirmwareRolloutBatchProgress {
  completedDevices: number;
  totalDevices: number;
  currentBatch: number;
  totalBatches: number;
}

export async function runFirmwareRolloutBatches(
  totalDevices: number,
  sendBatch: (batchSize: number) => Promise<Result<string>>,
  onProgress: (progress: FirmwareRolloutBatchProgress) => void,
): Promise<Result<string>> {
  const totalBatches = Math.ceil(
    totalDevices / FIRMWARE_ROLLOUT_BATCH_SIZE,
  );
  let completedDevices = 0;

  for (
    let batchIndex = 0;
    batchIndex < totalBatches;
    batchIndex += 1
  ) {
    const batchSize = Math.min(
      FIRMWARE_ROLLOUT_BATCH_SIZE,
      totalDevices - completedDevices,
    );
    onProgress({
      completedDevices,
      totalDevices,
      currentBatch: batchIndex + 1,
      totalBatches,
    });

    const result = await sendBatch(batchSize);
    if (result.status !== 'OK') {
      return result;
    }

    completedDevices += batchSize;
    onProgress({
      completedDevices,
      totalDevices,
      currentBatch: batchIndex + 1,
      totalBatches,
    });
  }

  return {
    status: 'OK',
    data: '',
  };
}
